import styled from 'styled-components';
import { theme } from '../../themes/theme';
export const SideContainer = styled.div `
  ${({ side }) => side &&
    `
      display: flex;
      align-items: center;
    `}
`;
export const ProgressBarContainer = styled.div `
  ${({ side }) => side &&
    `
      flex: 1;
      position: relative;
      margin: ${theme.spacing(3, 4)};
    `};
`;
